var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagetop"},[_c('a',{attrs:{"href":"#js-body"}},[_c('span',{staticClass:"pagetop-icon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","x":"0px","y":"0px","viewBox":"0 0 16 90"}},[_c('path',{staticClass:"st0",attrs:{"d":"M2.6,9.4L7,4.8V89h2V4.8l4.4,4.6l1.2-1.2L8,1.2l-6.6,7L2.6,9.4z"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }